let Config = {
	appid:'wx7145c571b99a8368',
	wx_auth_url: `https://open.weixin.qq.com/connect/oauth2/authorize?appid=#{{appid}}&redirect_uri=#{{url}}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`,
	
}
export default Config;


// WEBPACK FOOTER //
// ./src/utils/config.js